import { getTranslateByKey } from '@/main/services/utils';
import { ClickAwayListener, Grow, IconButton, Menu, MenuList, Paper, Popper } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { PropsWithChildren } from 'react';

import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';

import { ThreeDotsClaimProvider, useThreeDotsClaimContext } from './contex';
import * as S from './styles';

interface IThreeDotsClaimProps {
  idScreen: string;
}
function ThreeDotsClaim({
  children
}: PropsWithChildren<IThreeDotsClaimProps>) {
  const ID_MENU = 'id-menu-three-dots-quote';
  const {
    isOpen,
    setIsOpen,
    anchorEl,
    setAnchorEl,
    closeThreeDotsClaim,
    anchorRef
  } = useThreeDotsClaimContext();


  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  };
  function handleClose() {
    setAnchorEl(null);
  };

  const tooltipMessage = getTranslateByKey('information.clickToSeeTheActions');

  return (
    <S.Wrapper>
      <S.Container>
        <RenderTooltipMessage tooltipMessage={tooltipMessage}>
          <IconButton
            aria-haspopup="true"
            aria-controls={isOpen ? 'menu-list-grow' : undefined}
            ref={anchorRef}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
        </RenderTooltipMessage>

        <Menu
          id={ID_MENU}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          keepMounted
          onClose={handleClose}
          elevation={2}
          style={{ zIndex: 1 }}
        >
          {children}
        </Menu>

      </S.Container>
    </S.Wrapper>

  )
}

function KogThreeDotsClaimRoot(props: PropsWithChildren<IThreeDotsClaimProps>) {

  return (
    <ThreeDotsClaimProvider idScreen={props.idScreen}>
      <ThreeDotsClaim {...props} />
    </ThreeDotsClaimProvider>
  )
}

export default KogThreeDotsClaimRoot